export default "__VITE_ASSET__Bc_8aj$Y__"